import {Component} from '@angular/core';
import {RouterModule} from '@angular/router';
import {WaButtonDirective} from 'angular-awesome';
import {WaTextDirective} from 'angular-awesome';
import {WaDetailsDirective} from 'angular-awesome';
import {MarkdownComponent} from 'ngx-markdown';
import {WaTagDirective} from 'angular-awesome';
@Component({
	selector:'jwebmp-comp-bsprogress-bar',
	templateUrl:'./BSProgressBarPage.html',
	styles: [],
	styleUrls:['./BSProgressBarPage.scss'
],
	viewProviders:[],
	animations:[],
	providers:[],
	schemas:[],
	preserveWhitespaces:true,
	host:{},
	imports:[
		RouterModule,
		WaButtonDirective,
		WaTextDirective,
		WaDetailsDirective,
		MarkdownComponent,
		WaTagDirective,
],
	standalone:true
})
export class BSProgressBarPage
{
	mdContent_147 = `\`\`\`java
import com.jwebmp.plugins.bootstrap.progressbar.BSProgressBar;
\`\`\``;
	mdContent_148 = `\`\`\`java
new BSProgressBar<>()
\`\`\``;
	mdContent_149 = `\`\`\`java
new BSProgressBar<>(boolean striped)
\`\`\``;
	mdContent_150 = `\`\`\`java
var bar = new BSProgressBar<>(true);
bar.setPercentage(75);
bar.setAnimated(true);
bar.setType(BSColourTypes.Success);
bar.setShowValue(true);
\`\`\``;
}
